import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e2c8fa78"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "form-input"
};
const _hoisted_2 = {
  for: ""
};
const _hoisted_3 = {
  key: 0
};
import { useVModel } from "@vueuse/core";
export default /*#__PURE__*/_defineComponent({
  __name: 'form-input',
  props: {
    name: {},
    required: {
      type: Boolean,
      default: false
    },
    modelValue: {},
    textarea: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const mv = useVModel(props, "modelValue");
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.textarea ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
        key: 0,
        rows: "10",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(mv) ? mv.value = $event : null)
      }, null, 512)), [[_vModelText, _unref(mv)]]) : _withDirectives((_openBlock(), _createElementBlock("input", {
        key: 1,
        class: _normalizeClass({
          completed: !!_unref(mv)
        }),
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(mv) ? mv.value = $event : null)
      }, null, 2)), [[_vModelText, _unref(mv)]]), _createElementVNode("label", _hoisted_2, [_createTextVNode(_toDisplayString(_ctx.name) + " ", 1), _ctx.required ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*")) : _createCommentVNode("", true)])]);
    };
  }
});